export default __webpack_public_path__ + "static/media/Facebook.8c9a42c2.svg";